import {brand, Branded, TypeOf} from 'io-ts';
import isUUID from 'validator/lib/isUUID';
import {NonEmptyString} from './NonEmptyString';

interface UuidBrand {
    readonly Uuid: unique symbol;
}
export const Uuid = brand(NonEmptyString, (n): n is Branded<NonEmptyString, UuidBrand> => isUUID(n), 'Uuid');
export type Uuid = TypeOf<typeof Uuid>;

export const createUuid = (): Uuid => crypto.randomUUID() as Uuid;
